import * as types from '../mutation-types';
import api from '@/store/utils/api';


const state = {
    currentCreditApp: {},
};

const getters = {
    currentCreditApp: state => state.currentCreditApp,
};

const actions = {
    getCreditApp({ commit, rootGetters }, payload) {
        return api.get(`/credit-applicant/${payload.id}/`, { headers: { 'x-tecobi-auth': payload.authToken } }).then(res => {
            commit(types.UPDATE_CURRENT_CREDIT_APP, res);
            return res;
        });
    },
    createCreditApp({ commit }, payload) {
        const apiUrl = `/credit-applicant/`;
        return api
            .post(apiUrl, payload)
            .then((res) => {
                commit(types.UPDATE_CURRENT_CREDIT_APP, res);
                return res;
            });
    },
    patchCreditApp({ commit }, payload) {
        const apiUrl = `/credit-applicant/${payload.id}/`;
        return api
            .patch(apiUrl, payload, { headers: { 'x-tecobi-auth': payload.lead }})
            .then((res) => {
                commit(types.UPDATE_CURRENT_CREDIT_APP, res);
            });
    },
};

const mutations = {
    [types.UPDATE_CURRENT_CREDIT_APP](state, payload) {
        state.currentCreditApp = payload;
    },
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations,
};
